import {View} from 'react-native'

import {atoms as a, useTheme} from '#/alf'
import {BnuyFactContent, useBnuyFact} from '#/components/BnuyFact'

export function SidebarBnuyFacts() {
  const t = useTheme()
  /*
   * Lazy-initialized so a new fact is only picked once per mount (i.e. once
   * per page load) rather than on every re-render.
   */
  const [fact] = useBnuyFact()

  return (
    <View style={[a.p_lg, a.rounded_md, a.border, t.atoms.border_contrast_low]}>
      <BnuyFactContent fact={fact} />
    </View>
  )
}
